// src/pages/ResetPasswordPage.jsx
import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthForm from '../components/AuthForm';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!token) {
      setError('Invalid or expired reset link.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    // Replace this with an actual API call
    console.log('Resetting password to:', newPassword, 'with token:', token);
    setError('');
    setSubmitted(true);
    setTimeout(() => navigate('/login'), 2000);
  };

  if (submitted) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <h2>Password reset successful</h2>
        <p>You will be redirected to login...</p>
      </div>
    );
  }

  return (
    <AuthForm
      title="Set a New Password"
      image="/login.jpg"
      fields={[
        {
          name: 'newPassword',
          label: 'New Password',
          type: 'password',
          value: newPassword,
          onChange: (e) => setNewPassword(e.target.value),
        },
        {
          name: 'confirmPassword',
          label: 'Confirm Password',
          type: 'password',
          value: confirmPassword,
          onChange: (e) => setConfirmPassword(e.target.value),
        },
      ]}
      onSubmit={handleSubmit}
      submitLabel="Reset Password"
      showSocialIcons={false}
      footerLinks={[
        { href: '/login', label: 'Back to login' },
      ]}
    >
      {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
    </AuthForm>
  );
}
